import { Controller } from "@hotwired/stimulus"

// Darkens the divider of the last pinned column into one continuous line
const EDGE_COLOR = "#6b7280"

// Pins the leading columns of the table so the row identification stays visible
// while the table is scrolled horizontally.
export default class extends Controller {
  static targets = ["headerRow", "body"]
  static values = { count: Number }

  connect() {
    this.scroller = this.element.closest(".overflow-auto")
    this.boundPin = () => this.schedulePin()
    this.boundEdge = () => this.updateEdge()

    this.pin()

    this.rowObserver = new MutationObserver(this.boundPin)
    this.rowObserver.observe(this.bodyTarget, { childList: true })

    this.sizeObserver = new ResizeObserver(this.boundPin)
    this.sizeObserver.observe(this.element)

    this.scroller?.addEventListener("scroll", this.boundEdge, { passive: true })
  }

  disconnect() {
    this.rowObserver?.disconnect()
    this.sizeObserver?.disconnect()
    this.scroller?.removeEventListener("scroll", this.boundEdge)
    cancelAnimationFrame(this.frame)
  }

  schedulePin() {
    cancelAnimationFrame(this.frame)
    this.frame = requestAnimationFrame(() => this.pin())
  }

  pin() {
    if (this.countValue < 1) return

    const headerCells = this.pinnedCells(this.headerRowTarget)
    const offsets = []
    let left = 0

    headerCells.forEach(cell => {
      offsets.push(left)
      left += cell.getBoundingClientRect().width
    })

    this.edgeCells = []
    this.stickRow(headerCells, offsets, 20)
    Array.from(this.bodyTarget.children).forEach(row => this.stickRow(this.pinnedCells(row), offsets, 10))

    this.updateEdge()
  }

  stickRow(cells, offsets, zIndex) {
    cells.forEach((cell, index) => {
      cell.style.position = "sticky"
      cell.style.left = `${offsets[index]}px`
      cell.style.zIndex = zIndex
      cell.classList.add("sticky-column")
    })

    const edge = cells[offsets.length - 1]
    if (edge) this.edgeCells.push(edge)
  }

  updateEdge() {
    const color = this.scroller?.scrollLeft > 0 ? EDGE_COLOR : ""
    this.edgeCells?.forEach(cell => { cell.style.borderRightColor = color })
  }

  pinnedCells(row) {
    return Array.from(row.children)
                .filter(cell => cell.style.display === "table-cell")
                .slice(0, this.countValue)
  }
}
